import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSignOffSearchMutation } from "../../redux/catalogueService";
import {
  URLRelNameUpdated,
  breadcrumbNodesUpdated,
  releaseCatalogueNameUpdated,
  searchFormDataUpdated,
  urlRelNameUpdated,
  isDataReleaseChangedUpdated,
} from "../../redux/reducer";
import { DEC, RA, SOURCE, BATCH_POSITION } from "../../SearchConstants";
import Authorization from "../Authorization/Authorization";
import Modal from "../Modal/Modal";
import useModal from "../Modal/useModal";
import SearchDisplay from "../SearchDisplay/SearchDisplay";
import SearchForm from "../SearchForm/SearchForm";
import "./SearchRedirect.scss";
import "../TopHeader/TopHeader.scss";
import SelectionFilter from "../FilterSection/SelectionFilter";
import { useLazyGetAllDataReleasesQuery } from "../../redux/searchService";
import { isEmptyString } from "../../helperFunc";
import ReleaseNote from "./ReleaseNote";
import { AppContext } from "../../context/appContext";

let drFilterInitialValue = {
  label: "Data Releases",
  value: "data_release",
  placeholder: "",
  type: "select",
  options: [],
  selected: "",
};

let acktermsInitialValue = {
  ackTerms1: false,
  ackTerms2: false,
  ackTerms3: false,
};
function SearchRedirect() {
  const [isSourceCallOnNavigate, setIsSourceCallOnNavigate] = useState(false);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [signOffSearch] = useSignOffSearchMutation();
  const { relCatName } = useParams();
  const [dataReleaseFilter, setDataReleaseFilter] =
    useState(drFilterInitialValue);
  const navigate = useNavigate();
  const [ackTerms, setAckTerms] = useState(acktermsInitialValue);
  const [releaseName, setReleaseName] = useState("");
  const { searchFormData, urlRelName, isDataReleaseChanged} = useSelector(
    (state) => state.router
  );
  const [signOffError, setSignOffError] = useState();
  const [isCurrentCatalogueSignedOff, setIsCurrentCatalogueSignedOff] =
    useState();
  const [pageNotFound, setPageNotFound] = useState("");
  const [trigger, result] = useLazyGetAllDataReleasesQuery();
  const { toggleLoaderVisibility } = useContext(AppContext);
  const urlQueryParamsExists =
    searchParams.get("sourceid") ||
    searchParams.get("pointingname") ||
    searchParams.get(RA) ||
    searchParams.get(DEC)
      ? true
      : false;
  const [file, setFile] = useState(null);

  const handleFilterChange = (e) => {
    e.preventDefault();
    let selected = e.target.value;
    setDataReleaseFilter((prevData) => {
      return {
        ...prevData,
        selected,
      };
    });
    setReleaseName(e.target.value);
    navigate(`/release/${selected}/search`);
  };

  useEffect(() => {
    if (urlQueryParamsExists)
      dispatch(
        isDataReleaseChangedUpdated({
          isDataReleaseChanged: false,
        })
      );
    else {
      dispatch(
        isDataReleaseChangedUpdated({
          isDataReleaseChanged: true,
        })
      );
    }
    toggleLoaderVisibility(false);
  }, [urlRelName]);

  useEffect(() => {
    const sourceId = searchParams.get("sourceid");
    const pointingName = searchParams.get("pointingname");
    if (sourceId && pointingName) {
      dispatch(
        searchFormDataUpdated({
          searchFormData: {
            ra: "",
            dec: "",
            radius: "",
            cutout_size:"initial",
            searchBy: SOURCE,
          },
        })
      );
    }
    trigger();
  }, []);
  const checkIfDataReleaseNameDoesNotExist = (catalogues, release_name) => {
    const filteredDataRelease = catalogues.filter(
      (catalogue) => catalogue.releaseName === release_name
    );
    return filteredDataRelease.length === 0 ?  true: false;
  };
  useEffect(() => {
    const { catalogues: released_catalogues } = result?.data || {
      catalogues: [],
    };
    if (
      relCatName !== "latest-release" && released_catalogues.length!==0 &&
      checkIfDataReleaseNameDoesNotExist(released_catalogues, relCatName)
    ){
      setPageNotFound("Page Not Found");
    }
    else{
      setPageNotFound("");
    }
    const release_name =
      relCatName === "latest-release"
        ? released_catalogues[0]?.releaseName
        : relCatName;

    dispatch(urlRelNameUpdated({ urlRelName: release_name }));
    const options =
      released_catalogues?.map((drName) => {
        return {
          name: drName?.displayName,
          value: drName?.releaseName,
          signedOff: drName?.signedOff,
        };
      }) || [];
    setDataReleaseFilter((prevData) => {
      return {
        ...prevData,
        options,
        selected: release_name,
      };
    });
    setReleaseName(release_name);
    const currentReleaseEntry = released_catalogues.filter(
      (dr) => dr?.releaseName === release_name
    );
    setIsCurrentCatalogueSignedOff(currentReleaseEntry[0]?.signedOff);
  }, [relCatName, result]);

  useEffect(() => {
    if (result?.isFetching) {
      toggleLoaderVisibility(true);
    } else {
      toggleLoaderVisibility(false);
    }
  }, [result?.isFetching]);

  const backBtnBehaviour = () => {
    window.history.pushState(null, null, null);
  };
  useEffect(() => {
    window.addEventListener("popstate", backBtnBehaviour);
    dispatch(
      breadcrumbNodesUpdated({
        breadcrumbNodes: [],
      })
    );
    return () => window.removeEventListener("popstate", backBtnBehaviour);
  }, []);

  const handleSignoff = async () => {
    const catalogue_id =  searchParams.get("catalogueId");
    const result = await signOffSearch({release_name: urlRelName, catalogue_id});
    if (result?.error) {
      setSignOffError(result?.error?.error);
    }
    setAckTerms(acktermsInitialValue);
    trigger();
  };
  const changeHandler = (e) => {
    if (e.target.checked) {
      setAckTerms((prevAckTerms) => {
        return { ...prevAckTerms, [e.target.id]: true };
      });
    } else {
      setAckTerms((prevAckTerms) => {
        return { ...prevAckTerms, [e.target.id]: false };
      });
    }
  };

  const {
    isShowing,
    openModal: openSearchSignOffModal,
    closeModal: closeSearchSignOffModal,
  } = useModal();

  const shouldConfirmBeDisabled = !Object.values(ackTerms).every(
    (item) => item === true
  );

  const showReleaseNote =
    ((isEmptyString(searchFormData.ra) && isEmptyString(searchFormData.dec) && (isEmptyString(searchFormData.radius) && (searchFormData.cutout_size==="initial"))) ||
      isDataReleaseChanged) &&
    !isSourceCallOnNavigate &&
    !urlQueryParamsExists ;
  const showSearchDisplay = !showReleaseNote;
  if (!isEmptyString(pageNotFound))
    return (
      <>
        <span>{pageNotFound}</span>
      </>
    );
    else if(result?.isFetching) return ;
  return (
    <>
      <Modal
        isShowing={isShowing}
        close={closeSearchSignOffModal}
        title="Sign Off search"
        onConfirm={handleSignoff}
        shouldConfirmBeDisabled={shouldConfirmBeDisabled}
      >
        Do you want to sign off <b>{urlRelName}</b>?
        <div className="checkbox-section">
          <div>
            <input type="checkbox" id="ackTerms1" onChange={changeHandler} />
            <label htmlFor="ackTerms1">
              Have you validated the correctness of data & artefacts?
            </label>
          </div>
          <div>
            <input type="checkbox" id="ackTerms2" onChange={changeHandler} />
            <label htmlFor="ackTerms2">
              Have you verified the selected SPW's that will be released?
            </label>
          </div>
          <div>
            <input type="checkbox" id="ackTerms3" onChange={changeHandler} />
            <label htmlFor="ackTerms3">
              Are the release notes verified for the public release?
            </label>
          </div>
        </div>
      </Modal>

      <div className={isSourceCallOnNavigate ? "" : "search-container"}>
        {!isSourceCallOnNavigate && (
          <>
            <div className="top-header">
              <SelectionFilter
                filter={dataReleaseFilter}
                onChange={handleFilterChange}
                defaultValue={dataReleaseFilter.selected}
              />
              <a
                className="download-catalogue-btn"
                href={`/catalogue/catalogue_${urlRelName}_all.csv`}
              >
                Download Catalogue
              </a>
            </div>
            <Authorization>
              {isCurrentCatalogueSignedOff != null &&
                !isCurrentCatalogueSignedOff && (
                  <button
                    className="signoff-btn"
                    onClick={openSearchSignOffModal}
                  >
                    Signoff
                  </button>
                )}
            </Authorization>

            <SearchForm file={file} setFile={setFile} />
          </>
        )}
        {showSearchDisplay && (
          <SearchDisplay
            isSourceCallOnNavigate={isSourceCallOnNavigate}
            setIsSourceCallOnNavigate={setIsSourceCallOnNavigate}
            batchImagefile={file}
          />
        )}
        {signOffError && <p className="error signoff-error">{signOffError}</p>}

        {showReleaseNote && (
          <ReleaseNote
            dataReleaseFilter={dataReleaseFilter}
            releaseName={releaseName}
            setReleaseName={setReleaseName}
          />
        )}
      </div>
    </>
  );
}

export default SearchRedirect;
